/**
 * Next redemption Xero billing cron run (:00 and :30 each hour, Australia/Sydney server).
 */
export function nextRedemptionBillingRun(fromDate = new Date()) {
  const d = new Date(fromDate.getTime());
  const next = new Date(d);
  const m = d.getMinutes();
  if (m < 30) {
    next.setMinutes(30, 0, 0);
  } else {
    next.setHours(next.getHours() + 1, 0, 0, 0);
  }
  if (next.getTime() <= d.getTime()) {
    next.setMinutes(next.getMinutes() + 30, 0, 0);
  }
  return next;
}

export function formatNextBillingRunLabel(fromDate = new Date()) {
  const next = nextRedemptionBillingRun(fromDate);
  return next.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function resolveBillingVerificationStatus(redemption) {
  if (!redemption) return "unverified";
  const stored = redemption.billingVerificationStatus;
  if (stored) return stored;
  if (redemption.invoiceID) return "verified";
  if (redemption.xeroBillQueueStatus === "failed") return "billing_failed";
  if (
    redemption.xeroBillQueueStatus === "queued" ||
    redemption.xeroBillQueueStatus === "processing"
  ) {
    return "xero_pending";
  }
  return redemption.verified ? "verified" : "unverified";
}
